<div
  class="separator"
  [ngStyle]="{ 'background-color': background }"
  [style.width]="width"
></div>
